import saveGroupConsent from './saveGroupConsent';
import fetchDestinations from './fetchDestinations';
import getInitialPreferences from './getInitialPreferences';

export default async function acceptDefault() {
  const destinations = await fetchDestinations();
  saveGroupConsent(getInitialPreferences(), destinations);
}
